<app-loader [hidden]="!profileFormSaving"></app-loader>
<form class="margin-bottom-68" [formGroup]="profileForm" *ngIf="profileForm">
  <app-section>
    <div class="tab-section">
      <app-alert [alert]="alert"></app-alert>
      <div class="btn-parent">
        <app-form-header [title]="'Personal details'"></app-form-header>
        <app-button class="edit-btn" *ngIf="isEditableProfile && formEdit && coreService.isAdmin" [name]="'Edit'" [type]="'small-outlined'" (btnClick)="formEdit = !formEdit; alert = null;"></app-button>
      </div>
      <div *ngIf="selectedUser && selectedUser.updatedOn">
        <span class="field-name">Active user</span>
        <app-input-radio-button
          [labelName]="'Yes'"
          [inputFormControl]="profileForm?.controls?.isActive"
          [name]="'activeUser'"
          [readOnlyMode]="formEdit"
        >
        </app-input-radio-button>
        <app-input-radio-button
          [labelName]="'No'"
          [inputFormControl]="profileForm?.controls?.isActive"
          [name]="'activeUser'"
          [readOnlyMode]="formEdit"
      >
      </app-input-radio-button>
      </div>
      <div>
        <app-input-textbox
          [labelName]="'First name'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.firstName"
        >
        </app-input-textbox>
        <app-input-textbox
          [labelName]="'Last name'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.lastName"
        ></app-input-textbox>
      </div>
      <div>
        <app-input-textbox
          [labelName]="'Preferred name'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.preferredName"
        >
        </app-input-textbox>
      </div>
      <div>
        <app-dropdown
          [labelName]="'Gender'"
          [submitted]="submittedProfileForm"
          [options]="genderCodeOptions"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.genderCode"
        ></app-dropdown>
      </div>
      <div>
        <app-input-textbox
          [labelTextTransformNone]="true"
          [labelName]="'BHP Login'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.loginName"
        >
        </app-input-textbox>
      </div>

      <!-- <div>
        <app-input-textbox
          [labelName]="'Company'"
          [submitted]="submittedProfileForm"
          [inputFormControl]="profileForm?.controls?.company"
        >
        </app-input-textbox>
      </div> -->

      <div>
        <app-dropdown
          [labelName]="'Company'"
          [submitted]="submittedProfileForm"
          [options]="userTypeOptions"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.userTypeCode"
        ></app-dropdown>
      </div>

      <div>
        <app-input-textbox
          [labelName]="'Email Address'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.adEmailID"
        >
        </app-input-textbox>
        <div class="inline-block">
          <app-input-textbox
            [labelName]="'Notification Email Address'"
            [submitted]="submittedProfileForm"
            [readOnlyMode]="formEdit"
            [inputFormControl]="profileForm?.controls?.notificationEmailID"
          >
          </app-input-textbox>

          <app-input-checkbox
            [labelName]="'Same as email'"
            *ngIf="!formEdit"
            [inputFormControl]="profileForm?.controls?.sameEmail"
          >
          </app-input-checkbox>
        </div>
      </div>

      <div>
        <app-input-textbox
          [labelName]="'Work number'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.workPhoneNumber"
        >
        </app-input-textbox>
        <app-input-textbox
          [labelName]="'Mobile Phone'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.mobileNumber"
        >
        </app-input-textbox>
      </div>
      <app-form-header [title]="'Role details'"></app-form-header>
      <div>
        <app-input-textbox
          [labelName]="'Current Position'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.currentPosition"
        >
        </app-input-textbox>
      </div>
      <div class="search-field">
        <app-search-single-user
          [labelName]="'Reporting Manager Name'"
          [inputFormControl]="profileForm?.controls?.managerLoginID"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [users]="usersList"
          (onSelectUser)="onReportingManagerSelected($event)"
        >
        </app-search-single-user>
      </div>
      <div>
        <app-dropdown
          [labelName]="'First Language'"
          [submitted]="submittedProfileForm"
          [options]="languageOptions"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.firstLangCode"
        ></app-dropdown>
        <app-dropdown
          [labelName]="'Fluency'"
          [submitted]="submittedProfileForm"
          [options]="languageFluencyOptions"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.firstLangFluencyCode"
        ></app-dropdown>
      </div>
      <div>
        <app-dropdown
          [labelName]="'Second Language'"
          [submitted]="submittedProfileForm"
          [options]="languageOptions"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.secondLangCode"
        ></app-dropdown>
        <app-dropdown
          [labelName]="'Fluency'"
          [submitted]="submittedProfileForm"
          [options]="languageFluencyOptions"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.secondLangFluencyCode"
        ></app-dropdown>
      </div>
      <div>
        <app-dropdown
          [labelName]="'Role Type'"
          [submitted]="submittedProfileForm"
          [options]="roleTypeOptions"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.roleTypeCode"
        ></app-dropdown>
        <app-dropdown
          [labelName]="'Predominant Role'"
          [submitted]="submittedProfileForm"
          [options]="roleTypeOptions"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.preDominantRoleTypeCode"
        ></app-dropdown>
      </div>
      <div>
        <app-input-textbox
          [labelName]="'Office address'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.officeLocation"
        >
        </app-input-textbox>
      </div>
      <div>
        <app-dropdown
          [labelName]="'Access Level'"
          [submitted]="submittedProfileForm"
          [options]="accessLevelOptions"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.accessTypeCode"
        ></app-dropdown>
      </div>
      <div>
        <app-input-textarea
          [labelName]="'Notes'"
          [submitted]="submittedProfileForm"
          [readOnlyMode]="formEdit"
          [inputFormControl]="profileForm?.controls?.notes"
        >
        </app-input-textarea>
      </div>
    </div>
  </app-section>
</form>
    <div class="sticky-btns" *ngIf="!formEdit">
      <app-section>
        <div class="sticky-btn-container">
          <app-button
            [name]="'CANCEL'"
            [type]="'cancel'"
            (btnClick)="cancel()"
          >
          </app-button>
          <app-button
            [name]="selectedUser && selectedUser.updatedOn ? 'update user' : 'SAVE USER'"
            [type]="'success'"
            (btnClick)="saveUser()"
          ></app-button>
          <app-button
            *ngIf="showBackCPQPNavigationButton"
            [name]="'Back to CP/QP Nominations'"
            [type]="'secondary'"
            (btnClick)="onBackToWorkFlow()"
            [textTransformNone]="true"
          >
          </app-button>
        </div>
      </app-section>
    </div>
<app-user-status
  *ngIf="showInactiveUserPopup"
  [header]="'Are you sure?'"
  [message]="popupMessage"
  (onClose)="closeUserStatusPopup()"
  (onConfirm)="onConfirm()"
></app-user-status>
<app-user-status
  *ngIf="showUnSavedChangesPopup"
  [header]="'Are you sure?'"
  [message]="popupMessage"
  (onClose)="closeUnsaveChangesPopup()"
  (onConfirm)="onCancellationConfirm()"
></app-user-status>
